import { ACTION_TYPES } from '../constants';

export default (url, data) => ({
  type: ACTION_TYPES.FETCH_VOD_URL_SUCCESS,
  payload: {
    url,
    data
  }
});
